import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private httpCount = 0;
  private navCount = 0;
  private uiCounters = new Map<string, number>();

  private readonly state = new BehaviorSubject<LoadingState>({
    visible: false,
    zIndex: LoadingZLevel.UI
  });

  readonly loader$ = this.state.asObservable();

  httpStart() {
    this.httpCount++;
    this.emit();
  }

  httpEnd() {
    this.httpCount = Math.max(0, this.httpCount - 1);
    this.emit();
  }

  navStart() {
    this.navCount++;
    this.emit();
  }

  navEnd() {
    this.navCount = Math.max(0, this.navCount - 1);
    this.emit();
  }

  uiStart(key: string) {
    this.uiCounters.set(key, (this.uiCounters.get(key) ?? 0) + 1);
    this.emit();
  }

  uiEnd(key: string) {
    const count = (this.uiCounters.get(key) ?? 0) - 1;

    if (count <= 0) {
      this.uiCounters.delete(key);
    } else {
      this.uiCounters.set(key, count);
    }

    this.emit();
  }

  private emit() {

    let visible = false;
    let zIndex = LoadingZLevel.UI;

    if (this.uiCounters.size > 0) {
      visible = true;
      zIndex = LoadingZLevel.UI;
    }

    if (this.navCount > 0) {
      visible = true;
      zIndex = Math.max(zIndex, LoadingZLevel.Navigation);
    }

    if (this.httpCount > 0) {
      visible = true;
      zIndex = Math.max(zIndex, LoadingZLevel.Http);
    }

    this.state.next({ visible, zIndex });
  }
}

export interface LoadingState {
  visible: boolean;
  zIndex: number;
}

export enum LoadingZLevel {
  UI = 1000,
  Navigation = 1500,
  Http = 2000,
}